var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[(_vm.getIsAuthorized)?[(_vm.getUserIsAdministrator)?_c('Admin'):(_vm.getUserIsManager || _vm.getUserIsClientAdmin)?_c('Manager'):_vm._e()]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }